export const SASTRIFY_ORGANIZATIONS_LIST: { name: string; id: string }[] = [
	{ id: '4195403202430', name: 'Picanova GmbH' },
	{ id: '237288491560', name: 'Audiense' },
	{ id: '466152870774', name: 'Cuponation GmbH' },
	{ id: '2032067431336', name: 'Ecosia' },
	{ id: '3639518119421', name: 'sennder' },
	{ id: '4036049946867', name: 'Nexxiot AG' },
	{ id: '878353045469', name: 'Blacklane GmbH' },
	{ id: '1316598165297', name: 'Clark Holding SE' },
	{ id: '2535930462835', name: 'Moralis' },
	{ id: '1992485302955', name: 'Chip Financial Ltd' },
	{ id: '308761334273', name: 'Wunder Mobility' },
	{ id: '3421713610628', name: 'NavVis GmbH' },
	{ id: '939995944454', name: 'Audibene' },
	{ id: '1703161492524', name: 'Xentral ERP Software GmbH' },
	{ id: '3028601349500', name: 'hypatos' },
	{ id: '925223288960', name: 'Kimiagroup' },
	{ id: '2099980749258', name: 'EGYM' },
	{ id: '1048272495832', name: 'Billie.io' },
	{ id: '2319537427920', name: 'Shore GmbH' },
	{ id: '3833375235765', name: 'Aztec Labs' },
	{ id: '2774216517990', name: 'Carepay' },
];
